import React, { useContext, useEffect, useState } from "react";
import BarChartComp from "./myPredictions";
import PredictionContext from "../../context/predictionFlow/predictionContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import charticon from "../../assets/icons/Path 23145.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  addUserPrediction,
  getCopiedPollsterPrediction,
  getPartyList,
  getPreviousUserPrediction,
  getVoterCategoryList,
  resetPollFields,
} from "../../redux/actions/pollingAction";
import { toTitleCase } from "../../helpers/TitleCase";
import { sanitizeNumericInput } from "../../helpers/color/sanitizeNumaricInput";
import { isRowExceedingLimit } from "../../helpers/utilities";
import PredictionStepper from "../../pages/prediction/predictionStepper";

const NewPrediction = ({ freshPredict }) => {
  const [data, setData] = useState([]);
  const [rowErrors, setRowErrors] = useState({});
  console.log("🚀 ~ NewPrediction ~ rowErrors:", rowErrors)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { prediction, setPrediction, resetPrediction } =
    useContext(PredictionContext);
  const [payload, setPayload] = useState({});
  const [tableData, setTableData] = useState([]);
  const params = useParams();
  const [searchParams] = useSearchParams();
  const searchParam = searchParams.get("select");
  const categoryType = searchParams?.get("modify") || "";
  const pollster = JSON.parse(searchParams?.get("pollster"));

  const {
    VoterCategoryListResponse,
    PartyListResponse,
    AddPredictionResponse,
    PreviousPredictionData,
    CopiedPollsterPredictionResponse,
  } = useSelector((state) => state?.pollWeb);
    console.log("🚀 ~ NewPrediction ~ VoterCategoryListResponse:", VoterCategoryListResponse)
    console.log("🚀 ~ NewPrediction ~ PartyListResponse:", data)

  console.log("PreviousPredictionData", PreviousPredictionData);

  const isVerified = localStorage.getItem("accessToken");
  useEffect(() => {
    if (!isVerified) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    dispatch(resetPollFields());
    dispatch(
      getVoterCategoryList({
        country:
          prediction?.selectCountry?.id || localStorage.getItem("country"),
        state: prediction?.electionTypeData?.state || "",
        slug: categoryType,
      })
    );
    if (searchParam === "copy-previous-version") {
      const state = prediction?.electionTypeData?.state;
      dispatch(
        getPreviousUserPrediction({
          country:
            prediction?.selectCountry?.id || localStorage.getItem("country"),
          ...(state ? { state: state } : {}),
        })
      );
    } else if (searchParam === "copy-best" || searchParam === "copy-averages") {
      const state = prediction?.electionTypeData?.state;
      const payload = {
        slug: categoryType,
        prediction_type: searchParam,
        category_Id: pollster,
        country:
          prediction?.selectCountry?.id || localStorage.getItem("country"),
        ...(state ? { state: state } : {}),
      };
      dispatch(getCopiedPollsterPrediction(payload));
    }
    dispatch(
      getPartyList({
        country:
          prediction?.selectCountry?.id || localStorage.getItem("country"),
        ...(prediction?.electionTypeData?.state && {
          state: prediction?.electionTypeData?.state ?? null,
        }),
      })
    );
    // dispatch(getPartyList(params?.id));
    if (prediction?.selectCountry === null) {
      navigate("/prediction");
    }
  }, [params.id, searchParam]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const [tableTransformedData, setTableTransformedData] = useState([]);
  console.log("🚀 ~ NewPrediction ~ tableTransformedData:", tableTransformedData)
  useEffect(() => {
    let transformedData = [];

    if (searchParam === "copy-best" || searchParam === "copy-averages") {
      if (CopiedPollsterPredictionResponse?.predictionArray?.length) {
        transformedData = CopiedPollsterPredictionResponse.predictionArray.map(
          (item) => ({
            partyId: item?.partyId,
            categoryId: item?.voter_category_Id,
            value: item?.values,
          })
        );
      }
    } else if (searchParam === "copy-previous-version") {
      if (PreviousPredictionData?.predictionArray?.length) {
        transformedData = PreviousPredictionData.predictionArray.map(
          (item) => ({
            partyId: item?.partyId,
            categoryId: item?.voter_category_Id,
            value: item?.values,
          })
        );
      }
    } else {
      setIsDataLoading(false);
    }

    // Only update state if transformedData is different
    setTableTransformedData((prev) =>
      JSON.stringify(prev) !== JSON.stringify(transformedData)
        ? transformedData
        : prev
    );
    // If data exists, update tableData directly
    if (transformedData.length > 0) {
      setTableData(transformedData);
    }
  }, [PreviousPredictionData, CopiedPollsterPredictionResponse, searchParam]);

  useEffect(() => {
    if (AddPredictionResponse && AddPredictionResponse?.data) {
      alert(AddPredictionResponse?.msg);
      navigate(`/prediction/my_predictions/${AddPredictionResponse?.data?.id}`);
      dispatch(resetPollFields());
    }
  }, [AddPredictionResponse]);

  useEffect(() => {
    console.log("🚀 ~ NewPrediction ~ searchParam:", searchParam)
    if (searchParam === "copy-best" || searchParam === "copy-averages") {
      if (
        CopiedPollsterPredictionResponse &&
        CopiedPollsterPredictionResponse?.VoterCategory?.length > 0
      ) {
        const formattedData =
          CopiedPollsterPredictionResponse?.VoterCategory?.map((item) => ({
            category: item?.name,
            id: item?.id,
          }));

        setData(formattedData);
        setIsDataLoading(false);
      }
    } else if (searchParam === "copy-previous-version") {
      if (
        PreviousPredictionData &&
        PreviousPredictionData?.VoterCategory?.length > 0
      ) {
        const formattedData = PreviousPredictionData?.VoterCategory?.map(
          (item) => ({
            category: item?.name,
            id: item?.id,
          })
        );
        setData(formattedData);
        setIsDataLoading(false);
      }
    } else {
      console.log("🚀 ~ NewPrediction ~ VoterCategoryListResponse:", VoterCategoryListResponse)
      if (VoterCategoryListResponse && VoterCategoryListResponse?.length > 0) {
        const formattedData = VoterCategoryListResponse?.map((item) => ({
          category: item?.name,
          id: item?.id,
        }));
        setData(formattedData);
        setIsDataLoading(false);
      }
    }
  }, [
    VoterCategoryListResponse,
    CopiedPollsterPredictionResponse,
    PreviousPredictionData, // ✅ Added this
    searchParam,
  ]);

  const predictionbuttonArray = [
    { label: "New Prediction", path: "" },
    // { label: "Completed Predictions", path: "" },
    { label: "My Live Predictions", path: "/prediction" },
    { label: "Followed Predictions", path: "/prediction/followed_prediction" },
    // { label: "Followed Profiles", path: "" },
  ];

  const handleNavigate = (path, label) => {
    if (path) {
      if (label === "Followed Predictions") {
        navigate(path);
      } else {
        window.location.reload();
      }
    }
  };

  const handleFreshPrediction = (val) => {
    if (
      payload?.predictionArray?.length ===
      VoterCategoryListResponse?.length * PartyListResponse?.partyData?.length
    ) {
      setPrediction((prev) => ({ ...prev, freshPredict: val }));
      if (JSON.stringify(rowErrors) === "{}") {
        dispatch(addUserPrediction(payload));
        dispatch(resetPollFields());
      } else {
        alert(
          "Please adjust the values, the contribution should not exceed 100%."
        );
      }
    } else {
      alert("Please fill all the fields");
    }
  };

  const handleCopyPrev = (val) => {
    console.log(`🚀 ~ handleCopyPrev ~ JSON.stringify(rowErrors) === "{}":`, JSON.stringify(rowErrors) === "{}")
    if (JSON.stringify(rowErrors) === "{}") {
      setPrediction({ ...prediction, freshPredict: val });
      const formattedData = {
        predictionSelectionId: searchParam,
        predictionId: prediction?.selectCountry?.predictionId,
        state: params?.id,
        country: prediction?.selectCountry?.id,
        pollTypeId: prediction?.electionTypeData?.id,
        predictionArray: tableData,
      };
      dispatch(addUserPrediction(formattedData));
    } else {
      alert(
        // "values exceeding the limit!, please adjust the values and try again"
        `Seats count cannot exceed ${PartyListResponse?.stateAndConstituencyData?.no_of_seats}!`
      );
    }
  };

  // const getCurrentStep = () => {
  //   console.log("prediction", prediction);
  //   if (!prediction.newPrediction) return 0;
  //   if (!prediction.selectCountry) return 1;
  //   if (
  //     !prediction.electionTypeData?.prediction ||
  //     !prediction.electionTypeData?.type
  //   )
  //     return 2;
  //   return 3;
  // };

  const saveData = () => {
    const formattedData = {
      predictionSelectionId: searchParam,
      predictionId: prediction?.selectCountry?.predictionId,
      state: params?.id,
      country: prediction?.selectCountry?.id,
      pollTypeId: prediction?.electionTypeData?.id,
      predictionArray: data.flatMap((row) =>
        Object.keys(row)
          .filter(
            (key) =>
              key !== "category" && key !== "Contribution" && key !== "id"
          )
          ?.map((key) => ({
            partyId: PartyListResponse?.partyData?.find(
              (party) => party.abbreviation === key
            )?.id,
            categoryId: row.id,
            value: row[key],
          }))
      ),
    };
    setPayload(formattedData);
  };
  useEffect(() => {
    if (data?.length > 0) {
      saveData();
    }
  }, [data]);

  const handleChange = (index, partyName, inputValue) => {
    let newValue = parseFloat(inputValue.replace("%", "")) || 0;

    // console.log("data", data);

    setData((prevData) => {
      const updatedData = prevData.map((row, rowIndex) =>
        rowIndex === index ? { ...row, [partyName]: newValue } : row
      );

      const currentSum = Object.entries(updatedData[index])
        .filter(([key]) => !["category", "Contribution", "id"].includes(key))
        .reduce((sum, [, val]) => sum + (parseFloat(val) || 0), 0);

      // Get the row category
      const category = updatedData[index]["category"];
      console.log("🚀 ~ handleChange ~ category:", category)

      // Set a flexible limit based on category
      const contributionLimit =
        category === "seats"
          ? PartyListResponse?.stateAndConstituencyData?.no_of_seats
          : 100;

      // Avoid unnecessary re-renders
      if (updatedData[index]["Contribution"] === currentSum) return prevData;

      updatedData[index]["Contribution"] = currentSum;

      setRowErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (currentSum > contributionLimit) {
          updatedErrors[
            index
          ] = `Sum exceeds ${contributionLimit}! Please adjust the values.`;
        } else {
          delete updatedErrors[index];
        }
        return updatedErrors;
      });

      return updatedData;
    });
  };

  const getRowClassName = (index, row) => {
    const totalValue = tableData
      ?.filter((entry) => entry.categoryId === row.id)
      ?.reduce((sum, entry) => sum + (parseFloat(entry.value) ?? 0), 0);

    if (
      (row.category === "seats" &&
        totalValue >
        PartyListResponse?.stateAndConstituencyData?.no_of_seats) ||
      (row?.category !== "seats" && totalValue > 100)
    ) {
      return "bg-red-500 relative";

    }
    return index % 2 === 0 ? "bg-[#FCF3F0]" : "bg-[#E7F7FD]";
  };

  const handlePreChange = (categoryId, partyId, newValue) => {
    let newIntValue = parseInt(newValue.replace("%", ""), 10) || 0;

    setTableData((prevTableData) => {

      const updatedData = prevTableData.map((entry) =>
        entry.categoryId === categoryId && entry.partyId === partyId
          ? { ...entry, value: newIntValue }
          : entry
      );

      // 🔹 Calculate the sum of all contributions in the same category
      const currentSum = updatedData
        .filter((entry) => entry.categoryId === categoryId)
        .reduce((sum, entry) => sum + (parseFloat(entry.value) || 0), 0);

      if (
        currentSum > PartyListResponse?.stateAndConstituencyData?.no_of_seats
      ) {
        alert(
          `Seats count cannot exceed ${PartyListResponse?.stateAndConstituencyData?.no_of_seats}!`
        );
      }
      // 🔹 Update validation errors
      setRowErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (currentSum > PartyListResponse?.stateAndConstituencyData?.no_of_seats) {
          updatedErrors[categoryId] =
            "Sum exceeds 100! Please adjust the values.";
        } else {
          delete updatedErrors[categoryId];
        }
        return updatedErrors;
      });
      console.log("🚀 ~ NewPrediction ~ rowErrors:", rowErrors)

      return updatedData;
    });
  };
  console.log("🚀 ~ NewPrediction ~ rowErrors:", rowErrors)

  const handleReset = () => {
    setTableData((prevData) =>
      prevData.map((item) => ({
        ...item,
        value: "",
      }))
    );
  };

  return (
    <>
      <div className="bg_home flex flex-col pb-8 h-auto">
        <div className="bg_home md:bg-[#F7F8FA] md:px-4 min-[955px]:px-40 flex flex-col pb-6 md:py-5 h-auto">
          <div className="bg-white w-full rounded-xl shadow-sm md:p-5">
            <div className="px-1">
              <PredictionStepper />
              <div className="my-2 text-[12px] text-[#7F8FA4] hidden sm:flex">
                {prediction?.selectCountry?.name && (
                  <div className="">{prediction?.selectCountry?.name}</div>
                )}
                {prediction?.electionTypeData?.type &&
                  prediction?.predictionTitle && (
                    <div className="mx-1">
                      {`> ${prediction?.electionTypeData?.type
                        }  > ${toTitleCase(prediction?.predictionTitle).replace(
                          "_",
                          " "
                        )}`}{" "}
                    </div>
                  )}
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 justify-start gap-1 md:gap-4 items-center p-3">
              {predictionbuttonArray?.map((label, index) => {
                return (
                  <div
                    key={index}
                    className={` text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center my-2 md:my-0 max-w-[15rem] ${label?.label === "New Prediction" &&
                      "bg-[#4252A8] text-white"
                      }`}
                    onClick={() => handleNavigate(label?.path, label?.label)}
                  >
                    <img src={charticon} alt="chart-icon" width={12} />
                    {label?.label}
                  </div>
                );
              })}
            </div>
            {!freshPredict ? (
              <div className="p-2 md:p-5">
                <h2 className="text-2xl font-semibold mb-4 text-[18px] capitalize">
                  {searchParam?.replaceAll("-", " ")}
                </h2>

                <div className=" rounded-2xl border-2 shadow-lg py-4 md:px-7 px-3 bg-white overflow-auto">
                  {isDataLoading ? (
                    <>No data available</>
                  ) : (
                    <>
                      {tableTransformedData?.length > 0 ? (
                        <table className="w-full border-collapse text-[14px]">
                          <thead>
                            <tr className="text-left">
                              <th className="p-2 min-w-[10rem]"> </th>
                              {PartyListResponse?.partyData?.map((party) => {
                                return (
                                  <th key={party?.id} className="p-2">
                                    {party?.abbreviation?.toUpperCase()}
                                  </th>
                                );
                              })}
                              <th className="p-2">Contribution</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.map((row, index) => (
                              <tr
                                key={index}
                                className={getRowClassName(index, row)}
                              >
                                <td className="py-2 px-6 font-semibold">
                                  {row?.category?.toUpperCase()}
                                </td>
                                {PartyListResponse?.partyData?.map((field) => (
                                  <td key={field?.id} className={`p-2  `}>
                                    <input
                                      type="text"
                                      value={
                                        tableData?.find(
                                          (entry) =>
                                            entry.categoryId === row.id &&
                                            entry.partyId === field.id
                                        )?.value
                                      }
                                      className={`w-[5rem] text-center p-1 rounded`}
                                      onChange={(e) =>
                                        handlePreChange(
                                          row.id,
                                          field.id,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                ))}
                                <td key={"Contribution"} className="p-2">
                                  <input
                                    type="text"
                                    disabled
                                    value={`${tableData?.reduce(
                                      (sum, entry) =>
                                        entry.categoryId === row.id
                                          ? sum + (Number(entry.value) || 0)
                                          : sum,
                                      0
                                    )}${row?.category !== "seats" ? "%" : ""}`}
                                    className="w-[5rem] text-center p-1 rounded font-semibold bg-[#DCDFE3]"
                                  />
                                </td>
                                {isRowExceedingLimit(row) && (
                                  <div className="bg-white p-5 border rounded-lg absolute shadow-2xl right-[-5px] top-[45px]">
                                    {row.category === "seats"
                                      ? `Total seats can not be more than ${PartyListResponse?.stateAndConstituencyData?.no_of_seats}, Please adjust.`
                                      : "Total Value can not be more than 100%, Please adjust the values."}
                                  </div>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : !PartyListResponse?.partyData || !data?.length > 0 ? (
                        <>No data available</>
                      ) : (
                        <div className="w-full overflow-x-auto no-scrollbar min-h-[9rem]">
                          <table className="w-full border-collapse text-[14px] min-w-[600px]">
                            <thead>
                              <tr className="text-left">
                                <th className="p-2 min-w-[10rem]"></th>
                                {PartyListResponse?.partyData?.map((party) => {
                                  return (
                                    <th key={party.id} className="p-2">
                                      {party?.abbreviation?.toUpperCase()}
                                    </th>
                                  );
                                })}
                                <th className="p-2">Contribution</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((row, index) => (
                                <tr
                                  key={index}
                                  className={`${rowErrors[index]
                                      ? "bg-red-400 relative"
                                      : index % 2 === 0
                                        ? "bg-[#FCF3F0]"
                                        : "bg-[#E7F7FD]"
                                    }`}
                                >
                                  <td className="py-2 px-6 font-semibold">
                                    {row?.category?.toUpperCase()}{" "}
                                  </td>
                                  {PartyListResponse?.partyData?.map(
                                    (field) => (
                                      <td key={field?.id} className="p-2 ">
                                        <input
                                          type="text"
                                          value={
                                            row?.[field?.abbreviation] ?? ""
                                          }
                                          className="w-[5rem] text-center p-1 rounded"
                                          onChange={(e) => {
                                            const value = sanitizeNumericInput(
                                              e.target.value
                                            );
                                            handleChange(
                                              index,
                                              field?.abbreviation,
                                              value
                                            );
                                          }}
                                        />
                                      </td>
                                    )
                                  )}
                                  <td key={"Contribution"} className="p-2">
                                    <input
                                      type="text"
                                      disabled
                                      value={`${row?.["Contribution"] || 0}${row?.category !== "seats" ? "%" : ""
                                        }`}
                                      className={`w-[5rem] text-center p-1  rounded 
                                    font-semibold bg-[#DCDFE3]
                                  `}
                                    />
                                  </td>
                                  {rowErrors[index] && (
                                    <div className="bg-white p-5 border rounded-lg absolute shadow-2xl right-[-5px] top-[45px]">
                                      {row.category === "seats"
                                        ? `Total seats can not be more than ${PartyListResponse?.stateAndConstituencyData?.no_of_seats}, Please adjust.`
                                        : "Total Value can not be more than 100%, Please adjust the values."}
                                    </div>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  )}
                  <div className="flex justify-end gap-3 mt-4 text-[14px]">
                    {tableTransformedData?.length > 0 && (
                      <button
                        className="bg-[#1A1A1A] text-white px-6 py-2 rounded-xl"
                        onClick={() => {
                          if (tableTransformedData?.length > 0) {
                            handleReset();
                          }
                        }}
                      >
                        Reset
                      </button>
                    )}
                    <button
                      className={`${isDataLoading ||
                          !PartyListResponse?.partyData ||
                          !data?.length > 0
                          ? "bg-gray-400 cursor-not-allowed opacity-50"
                          : "bg-[#4252A8]"
                        }  text-white px-6 py-2 rounded-xl`}
                      disabled={
                        isDataLoading ||
                        !PartyListResponse?.partyData ||
                        !data?.length > 0
                      }
                      onClick={() => {
                        if (tableTransformedData?.length > 0) {
                          handleCopyPrev(true);
                        } else {
                          handleFreshPrediction(true);
                        }
                      }}
                    >
                      Save & Submit
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {freshPredict && (
                  <div className="mt-8">
                    <BarChartComp />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPrediction;
